const colors = {
    darkgrey: "#212529",
    grey: "#adb5bd",
    white: "#faf9f9",
    red: "#FF7366",
    orange: "#FF7744",
    yellow: "#FFAB00",
    green: "#43A047",
    cyan: "#00BCD4",
    blue: "#79B0FB",
    purple: "#BF8CFC",
    pink: "#FB79B8",
    teal: "#00BFA5",
    coral: "#F58770",
    brown: "#CCA760",
    magenta: "#FB79F2",
};

export default colors;
